import { useContext } from 'react';

import WorkTemplateCreationModalContext, {
  ModalStep,
} from '@atom/components/common/workTemplateCreationModal/WorkTemplateCreationModalContext';
import { Stepper } from '@atom/mui';
import { isWorkTemplateInheritanceDisabled } from '@atom/utilities/tenantFeatureUtilities';

import DetailsView from './DetailsView';
import InheritanceView from './InheritanceView';
import TemplateTypeView from './TemplateTypeView';
import {
  MODAL_STEPS,
  MODAL_STEPS_ARRAY,
  MODAL_STEPS_ARRAY_NO_INHERITANCE,
} from './workTemplateOptions';

import classes from './workTemplateCreationModal.module.css';

const { StepLabel, Step } = Stepper;

const MainCreationModalView = () => {
  const { activeStep } = useContext(WorkTemplateCreationModalContext);

  const getContent = () => {
    const content = {
      [ModalStep.DETAILS]: <DetailsView />,
      [ModalStep.TEMPLATE_TYPE]: <TemplateTypeView />,
      [ModalStep.INHERITANCE]: <InheritanceView />,
    };

    return content[activeStep];
  };

  const STEPS_ARRAY = isWorkTemplateInheritanceDisabled
    ? MODAL_STEPS_ARRAY_NO_INHERITANCE
    : MODAL_STEPS_ARRAY;

  return (
    <div className={classes.modalContent}>
      <div className={classes.stepperContainer}>
        <Stepper
          activeStep={MODAL_STEPS[activeStep]?.index}
          orientation="vertical"
        >
          {STEPS_ARRAY.map(step => (
            <Step key={step.title}>
              <StepLabel>{step.title}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </div>
      <div className={classes.contentContainer}>{getContent()}</div>
    </div>
  );
};

export default MainCreationModalView;
